import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, onMounted } from 'vue'
  import { vOnClickOutside } from '@vueuse/components'
  import useIcons from '@/composables/useIcons'
  import useBreakpoint from '@/composables/useBreakpoint'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    title: {
      type: String,
      default: '',
    },
    hideContainer: {
      type: Boolean,
      default: false,
    },
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
    closeModalOnOutsideClick: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['close'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const { closeIcon } = useIcons()
  const { isMobileDevice } = useBreakpoint()

  const closeModal = () => {
    emit('close')
  }

  const closeModalWhenClickedOutside = () => {
    if (props.closeModalOnOutsideClick) {
      closeModal()
    }
  }

  const onKeydown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') closeModal()
  }

  onMounted(() => {
    document.body.style.setProperty('overflow', 'hidden')
    document.addEventListener('keydown', onKeydown)
  })

  onBeforeUnmount(() => {
    document.body.style.setProperty('overflow', '')
    document.removeEventListener('keydown', onKeydown)
  })

return { __sfc: true,emit, props, closeIcon, isMobileDevice, closeModal, closeModalWhenClickedOutside, onKeydown, onBeforeUnmount, onMounted, vOnClickOutside, useIcons, useBreakpoint }
}

})